import React, { useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const TOMOS = [{
  icon: '📘',
  title: 'La Fórmula',
  subtitle: 'Entendés el problema y cómo cortarlo de raíz.',
  bullets: ['Qué es la fatiga de decisión a las 7 AM', 'Los 8 dolores reales de la merienda escolar', 'El Método M.E.R.I.E.N.D.A. paso a paso', 'La fórmula simple de una merienda equilibrada'],
  result: 'Ya sabés qué hacer. La pregunta de qué mandar deja de existir.'
}, {
  icon: '📗',
  title: '60 Meriendas',
  subtitle: 'Un banco completo que reemplaza los posts guardados.',
  bullets: ['15 ideas en menos de 5 minutos', '15 para dejar listas la noche anterior', '10 económicas y 10 para días de calor', '10 fáciles de transportar'],
  result: 'Nunca más te quedás parada frente a la heladera.'
}, {
  icon: '📙',
  title: '5 Minutos',
  subtitle: 'Para las mañanas en que todo salió mal.',
  bullets: ['15 fichas de emergencia por velocidad real', 'Protocolo de la mañana apurada en 4 pasos', 'La alacena de emergencia', '4 semanas de meriendas express'],
  result: 'Ni las peores mañanas te ganan.'
}, {
  icon: '📕',
  title: 'Recetario',
  subtitle: 'Domingo de alivio: preparás una vez.',
  bullets: ['10 recetas dulces y 10 saladas', 'Guía de conservación y congelado', '4 combinaciones de domingo planificadas', 'Las 5 recetas recomendadas para empezar'],
  result: 'Cinco mañanas sin esa pregunta.'
}, {
  icon: '📓',
  title: 'Económicas',
  subtitle: 'Gastar menos sin que parezca menos.',
  bullets: ['Comparativa real: improvisar vs. planificar', '10 ingredientes rendidores del mercado uruguayo', 'Frutas por temporada en Uruguay', '20 meriendas con costo estimado'],
  result: 'El mismo presupuesto. Tres veces más variedad.'
}, {
  icon: '📔',
  title: 'Planificador',
  subtitle: 'El sistema que hace que todo funcione.',
  bullets: ['4 semanas completas y calendario de 30 días', 'Listas de compras e inventario imprimibles', 'Registro de meriendas favoritas', 'Tabla de reemplazos inteligentes'],
  result: 'Un mes organizado en 15 minutos el domingo.'
}];
const BONUSES = [{
  title: 'Semáforo de Meriendas',
  value: '$60 UYU',
  description: 'Para que nunca más te preguntes si lo que mandaste estuvo bien.',
  items: ['Verde, amarillo y rojo sin tecnicismos', 'Aplicado a las 60 meriendas del banco', 'Las 6 reglas para usarlo sin culpa', 'Plantilla semanal para completar']
}, {
  title: 'Meriendas de Emergencia',
  value: '$60 UYU',
  description: 'Para las mañanas en que todo se desarmó.',
  items: ['10 fichas ordenadas por velocidad', 'El protocolo de crisis en 4 pasos', 'La alacena de emergencia siempre lista', '3 semanas de emergencia completas']
}, {
  title: 'Etiquetas para Lonchera',
  value: '$60 UYU',
  description: 'Un pequeño pedacito de casa que lo acompaña.',
  items: ['40 etiquetas imprimibles', 'Etiquetas de amor, días y motivación', 'Especiales para días importantes', 'En blanco para personalizar']
}];
const METHOD = [['M', 'Mirá lo que tenés', 'Comprás solo lo que falta'], ['E', 'Elegí una base', 'Cada día diferente'], ['R', 'Rotá para no repetir', 'Variedad real semana a semana'], ['I', 'Incluí variedad', 'Colores, texturas, opciones'], ['E', 'Equilibrá sin complicarte', 'Sin saber de nutrición'], ['N', 'No compliques', 'Máximo 10 minutos'], ['D', 'Dejá algo listo', '30 minutos el domingo = semana resuelta'], ['A', 'Adaptá a tu familia', 'Tu sistema, tus tiempos, tus reglas']];
export function TomosAndBonos() {
  const [activeTomo, setActiveTomo] = useState(0);
  const tomo = TOMOS[activeTomo];
  return <>
      <section className="bg-brand-lightBlue px-4 py-16" data-id="element-277">
        <div className="mx-auto max-w-5xl" data-id="element-278">
          <header className="mx-auto max-w-3xl text-center" data-id="element-279">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-280">
              El corazón del sistema
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-281">
              El Método M.E.R.I.E.N.D.A.
            </h2>
          </header>
          <div className="mt-10 overflow-hidden rounded-2xl border border-brand-sky bg-white shadow-sm" data-id="element-282">
            <div className="grid grid-cols-1 divide-y divide-brand-sky md:grid-cols-2 md:divide-x md:divide-y-0" data-id="element-283">
              {METHOD.map(([letter, step, outcome]) => <div key={`${letter}-${step}`} className="flex gap-4 p-4" data-id="element-284">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-greenSoft font-display text-lg font-bold text-brand-green" data-id="element-285">
                    {letter}
                  </span>
                  <span data-id="element-286">
                    <strong className="block text-brand-deep" data-id="element-287">{step}</strong>
                    <small className="text-brand-text" data-id="element-288">{outcome}</small>
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-20" data-id="element-289">
        <div className="mx-auto max-w-5xl" data-id="element-290">
          <header className="text-center" data-id="element-291">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-292">
              Contenido completo
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-293">
              ¿Qué vas a recibir cuando comprás hoy?
            </h2>
          </header>
          <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-6" data-id="element-294">
            {TOMOS.map((item, index) => <button key={item.title} type="button" onClick={() => setActiveTomo(index)} className={`rounded-2xl border p-4 text-center transition-colors focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-sky ${activeTomo === index ? 'border-brand-orange bg-orange-50 shadow-sm' : 'border-slate-200 bg-white hover:border-brand-sky'}`} data-id="element-295">
                <span className="block text-3xl" data-id="element-296">{item.icon}</span>
                <span className="mt-2 block text-xs font-bold uppercase text-brand-gray" data-id="element-297">
                  Tomo {index + 1}
                </span>
                <span className="mt-1 block font-display text-sm font-bold text-brand-deep" data-id="element-298">
                  {item.title}
                </span>
              </button>)}
          </div>
          <article key={tomo.title} className="mx-auto mt-8 max-w-3xl rounded-3xl border border-brand-sky bg-brand-lightBlue p-7 md:p-9" data-id="element-299">
            <div className="flex items-start gap-4" data-id="element-300">
              <span className="text-4xl" data-id="element-301">{tomo.icon}</span>
              <div data-id="element-302">
                <p className="text-sm font-bold uppercase tracking-wider text-brand-orange" data-id="element-303">
                  Tomo {activeTomo + 1}
                </p>
                <h3 className="font-display text-2xl font-bold text-brand-deep" data-id="element-304">
                  {tomo.title}
                </h3>
                <p className="mt-2 font-medium text-brand-text" data-id="element-305">
                  {tomo.subtitle}
                </p>
              </div>
            </div>
            <ul className="mt-7 grid gap-3 md:grid-cols-2" data-id="element-306">
              {tomo.bullets.map(item => <li key={item} className="flex gap-2 font-medium text-brand-text" data-id="element-307">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-308" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-7 rounded-xl bg-white p-4 font-bold text-brand-deep" data-id="element-309">
              <span className="text-brand-orange" data-id="element-310">Resultado:</span>{' '}
              {tomo.result}
            </p>
          </article>
          <div className="mx-auto mt-12 max-w-3xl rounded-2xl border border-brand-sky bg-white p-6 shadow-sm" data-id="element-311">
            <h3 className="text-center font-display text-xl font-bold text-brand-deep" data-id="element-312">
              CADA TOMO INCLUYE:
            </h3>
            <div className="mt-6 grid gap-3 md:grid-cols-2" data-id="element-313">
              {['Sistema de planificación listo desde el día 1', 'Ideas organizadas por tu situación real', 'Recetas simples con ingredientes cotidianos', 'Guías de conservación y congelado', 'Planificadores y listas imprimibles', 'Precios orientativos en pesos uruguayos', '100% adaptado a Uruguay'].map(item => <p key={item} className="flex gap-2 font-medium text-brand-text" data-id="element-314">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-315" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-base px-4 py-20" data-id="element-316">
        <div className="mx-auto max-w-5xl" data-id="element-317">
          <header className="text-center" data-id="element-318">
            <h2 className="font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-319">
              + 3 Bonos Estratégicos incluidos
            </h2>
            <p className="mt-3 text-lg font-medium text-brand-text" data-id="element-320">
              Sin costo extra. En el kit completo. Siempre.
            </p>
          </header>
          <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-321">
            {BONUSES.map((bonus, index) => <article key={bonus.title} className="relative overflow-hidden rounded-2xl border border-brand-sky bg-white p-6 shadow-sm" data-id="element-322">
                <span className="absolute right-0 top-0 rounded-bl-xl bg-brand-orange px-3 py-1 text-xs font-bold text-white" data-id="element-323">
                  BONO {index + 1}
                </span>
                <span className="text-3xl" data-id="element-324">🎁</span>
                <h3 className="mt-4 font-display text-xl font-bold text-brand-deep" data-id="element-325">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-brand-text" data-id="element-326">{bonus.description}</p>
                <ul className="mt-5 space-y-2" data-id="element-327">
                  {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm font-medium text-brand-text" data-id="element-328">
                      <span className="text-brand-orange" data-id="element-329">✓</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-6 border-t border-brand-sky pt-4 font-bold" data-id="element-330">
                  <span className="text-brand-gray line-through" data-id="element-331">
                    Valor: {bonus.value}
                  </span>{' '}
                  <span className="ml-2 text-brand-green" data-id="element-332">GRATIS</span>
                </p>
              </article>)}
          </div>
          <div className="mx-auto mt-10 max-w-2xl rounded-2xl bg-brand-orange p-6 text-center text-white shadow-lg" data-id="element-333">
            <p className="font-display text-xl font-bold" data-id="element-334">
              🎁 $180 UYU en bonos — GRATIS
            </p>
            <p className="mt-1 text-orange-100" data-id="element-335">
              Incluidos en el kit completo. Siempre.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-brand-deep px-4 py-20 text-white" data-id="element-336">
        <div className="mx-auto max-w-5xl" data-id="element-337">
          <header className="mx-auto max-w-2xl text-center" data-id="element-338">
            <h2 className="font-display text-3xl font-bold text-brand-orange md:text-4xl" data-id="element-339">
              Tres familias. Un sistema que se adapta.
            </h2>
            <p className="mt-5 text-xl leading-relaxed text-slate-200" data-id="element-340">
              En Uruguay hay tres tipos de familias que están leyendo esto.
            </p>
          </header>
          <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-341">
            {[{
            icon: '🏠',
            title: 'LA FAMILIA QUE QUIERE PAZ MENTAL',
            body: 'Esa pregunta de todos los días te agota.',
            gain: 'Todo el mes planificado en una tarde. Las mañanas recuperadas.'
          }, {
            icon: '💰',
            title: 'LA FAMILIA CON PRESUPUESTO AJUSTADO',
            body: 'Querés darles buenas meriendas sin improvisaciones caras.',
            gain: 'Precios reales, frutas de estación y más variedad por menos.'
          }, {
            icon: '⭐',
            title: 'LA FAMILIA QUE QUIERE QUE VUELVA VACÍA',
            body: 'No alcanza con mandar algo. Querés que se lo coma.',
            gain: 'Ideas por situación y estrategias para involucrarlo en la elección.'
          }].map(profile => <article key={profile.title} className="rounded-2xl border border-white/20 bg-white/10 p-6" data-id="element-342">
                <span className="text-3xl" data-id="element-343">{profile.icon}</span>
                <h3 className="mt-4 font-display text-lg font-bold text-brand-orange" data-id="element-344">
                  {profile.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-200" data-id="element-345">
                  {profile.body}
                </p>
                <div className="mt-5 border-t border-white/15 pt-4" data-id="element-346">
                  <strong className="text-sm" data-id="element-347">Lo que te da:</strong>
                  <p className="mt-1 text-sm leading-relaxed text-brand-sky" data-id="element-348">
                    {profile.gain}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </section>
    </>;
}